// Reducer for Insights Keywords
import { createReducer, on, Action } from '@ngrx/store';
import * as InsightsKeywordsAction from './actions'
import { InsightsKeywordState, initialInsightsKeywordsState } from './state';

export const insightsKeywordStateFeatureKey = 'insightsKeywords';

const _insightsKeywordsReducer = createReducer(
    initialInsightsKeywordsState,
    // LIST [GET]
    on(InsightsKeywordsAction.getInsightsKeywords, state => ({ ...state, loading: true})),
    on(InsightsKeywordsAction.getInsightsKeywordsSuccess, (state, { keywords }) => ({...state, keywords, loading: false})),
    on(InsightsKeywordsAction.getInsightsKeywordsFailure, (state, { error }) => ({...state, error, loading: false})),
    // SAVE [POST]
    on(InsightsKeywordsAction.addInsightsKeyword, state => ({...state, loading: true})),
    on(InsightsKeywordsAction.addInsightsKeywordSuccess, (state, { message }) => ({ ...state, loading: false, message})),
    on(InsightsKeywordsAction.addInsightsKeywordError, (state, { error }) => ({ ...state, loading: false, error}))
);

export function insightsKeywordsReducer(state: InsightsKeywordState | undefined, action: Action) {
    return _insightsKeywordsReducer(state, action);
}
